import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';

/**
 * Redirects client_portal users who have not finished onboarding.
 */
export default function ClientPortalGate() {
  const user = useAuthStore((s) => s.user);
  const location = useLocation();

  if (user?.role === 'client_portal' && !user?.onboardingCompletedAt) {
    if (location.pathname !== '/client/onboarding') {
      return <Navigate to="/client/onboarding" replace />;
    }
  }

  if (user?.role === 'client_portal' && user?.onboardingCompletedAt && location.pathname === '/client/onboarding') {
    return <Navigate to="/client/dashboard" replace />;
  }

  return <Outlet />;
}
